import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=16ce8408&scoped=true&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"
import style0 from "./issue.vue?vue&type=style&index=0&id=16ce8408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ce8408",
  null
  
)

export default component.exports